package one.healthium.update_food_preferences.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class FoodPreferencesDto(
    @SerialName("preferences") val preferences: List<FoodPreferencesCategoryDto>
)
